import type { IMultiColumnProps } from 'blocks/MultiColumns'

import { MultiColumns, MultiColumnsGap } from 'blocks/MultiColumns'
import { MultiColumnsEpgBlockSC } from './MultiColumnsEpgBlock.styled'

export interface IMultiColumnsEpgBlock extends IMultiColumnProps {}

export const MultiColumnsEpgBlock = ({
  children,
  columnGap = MultiColumnsGap.ADAPTIVE_SIZE_10,
  ...rest
}: IMultiColumnsEpgBlock) => {
  return (
    <MultiColumnsEpgBlockSC {...rest}>
      <MultiColumns columnGap={columnGap} {...rest}>
        {children}
      </MultiColumns>
    </MultiColumnsEpgBlockSC>
  )
}
